module.exports = __webpack_public_path__ + "static/media/received_407817773334281.9d322044.jpg";